// Vendor
import styled from 'styled-components';

type ErrorWarningMessageProps = {
  status: 'warning' | 'error';
};

export const Content = styled.div`
  padding: 1rem;
  max-width: 1700px;
  margin: 0 auto;

  @media ${({ theme }) => theme.device.mobile} {
    padding: 1.5rem;
  }

  .income-verification-buttons {
    height: 56px;
    width: 56px;
    border-radius: 50%;
    border-color: ${({ theme }) => theme.color.blue[700]};
    justify-content: center;
  }
`;
export const IncomeVerificationTiles = styled.div`
  padding: 1rem;
  max-width: 1700px;
  margin: 0 auto;

  @media ${({ theme }) => theme.device.mobile} {
    padding: 1.5rem;
  }
  border: 11px solid ${({ theme }) => theme.color.blue[200]};
`;

export const NotesCard = styled.div`
  max-width: 720px;
  margin: 1.5rem auto 0;
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.gray[150]};
  border-radius: 8px;

  && > * {
    margin-top: 0;
  }
`;

export const IncomeResult = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  justify-content: center;
  display: flex;
`;

export const IncomeDataSummary = styled.div`
  text-align: center;
  justify-content: center;
  margin-bottom: 1.5rem;

  h2 {
    margin-bottom: 1.5rem;
  }
`;

export const ErrorWarningMessage = styled.div<ErrorWarningMessageProps>`
  color: ${({ theme, status }) =>
    status === 'warning' ? theme.color.black : theme.color.red[700]};
  max-width: 500px;
  margin: 0 auto;
`;

export const MismatchWarningMessage = styled.div`
  text-align: center;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  background: ${({ theme }) => theme.color.yellow[100]};
  border: 1px solid ${({ theme }) => theme.color.yellow[700]};
  border-radius: 8px;
  color: ${({ theme }) => theme.color.yellow[500]};
  font-size: 0.9rem;
`;

export const TileSectionHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 2rem 0 1.5rem;
  font-weight: 600;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.color.gray[700]};

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid ${({ theme }) => theme.color.gray[200]};
  }
`;
